import {Component, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {HttpClient} from "@angular/common/http";
import {environment} from '../../../environments/environment';
import {zipToZone} from '../../../assets/json/zipToZone';
import {saveAs} from 'file-saver';
import {MatDialog} from '@angular/material/dialog';
import {GenerateContractDialogComponent} from "../../components/dialog/generate-contract-dialog/generate-contract-dialog.component";
import {UtilService} from "../../services/util.service";
import {DataService} from "../../services/data.service";
import * as moment from "moment";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
@Component({
  selector: 'app-preferred-pricing',
  templateUrl: './preferred-pricing.component.html',
  styleUrls: ['./preferred-pricing.component.scss']
})

export class PreferredPricingComponent implements OnInit {
  isDesktop: boolean = true
  selectedMarket: string = '';
  selectedPjmUtility: string;
  selectedPjmStartDate: string;
  pjmStartDateList = [];
  ercotStartDateList = [];
  pjmCalculationResult: any = {};
  ercotCalculationResult: any = {};
  showPjmResult: boolean = false;
  showErcotResult: boolean = false;
  pjmError: string;
  ercotError: string;
  pjmLoading: boolean = false;
  ercotLoading: boolean = false;
  confirmAgreement: boolean = false;
  pjmAccounts;
  pjmAccountList: any;
  zipCode;
  zoneByZip;
  selectedContractType;
  pjmOpportunityName;
  ercotOpportunityName
  accountLength = {
    ComEd: {size: 10, description: 'Account Number must be 10 digits (e.g. 1234567890)'}
    , PPL: {size: 10, description: 'Account Number must be 10 digits (e.g. 1234567890)'}
    , PECO: {size: 10, description: 'Account Number must be 10 digits (e.g. 1234567890)'}
    , MetEd: {size: 20, description: 'Account Number must be 20 digits (e.g. 12345678901234567890)'}
    , Penelec_PA: {size: 20, description: 'Account Number must be 20 digits (e.g. 12345678901234567890)'}
    , 'Penn Power': {size: 20, description: 'Account Number must be 20 digits (e.g. 12345678901234567890)'}
    , 'West Penn Power': {size: 20, description: 'Account Number must be 20 digits (e.g. 12345678901234567890)'}
  }
  wrongAccountNumbers = [];

    constructor(private deviceService: DeviceDetectorService, private http: HttpClient, public dialog: MatDialog, public  dataService: DataService, public utilService : UtilService, public form: FormBuilder) {
    this.isDesktop = this.deviceService.isDesktop();
    this.zoneByZip = zipToZone;
  }

  openContractGenDialog() {

    let priceList = [];
    let utility;
    let accountList = [];
    let priceDetail;
    let startDate;
    if (this.selectedMarket == 'PJM') {
      this.validatePjmForm();
      priceDetail =  this.pjmCalculationResult ;
      utility = this.selectedPjmUtility;
      accountList = this.pjmAccountList ;
      startDate =this.selectedPjmStartDate;
    }
    if (this.selectedMarket == 'ERCOT' && ('month6' in this.ercotCalculationResult)) {
      priceDetail =  this.ercotCalculationResult ;
      utility = this.selectedErcotUtility;
      startDate =this.selectedErcotStartDate;

    }

    const dialogRef = this.dialog.open(GenerateContractDialogComponent
      , {
        data: {
          market: this.selectedMarket
          , contractType: this.selectedState
          , accountList: accountList
          , termPriceList: priceList
          , utility: utility
          , priceDetail: priceDetail
          , startDate: startDate
        }
        , panelClass: 'contract-generator-dialog'
      }
    );
    dialogRef.afterClosed();


    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  selectedErcotUtility: string;
  selectedErcotZone: string;
  selectedErcotLoadType: string;
  selectedErcotStartDate: string;
  selectedErcotKwhYear: string;

  requestForm: FormGroup;
  requestFormData: any[];
  stateOptions: any[] = [];
  disableStates: string[] = [];
  pjmEndDate: string;
  ercotEndDate: string;
  selectedState: string;

  async ngOnInit(): Promise<void> {
    this.getStartDateList()
    this.getStateOptions();
    await this.http.get('./assets/newQuoteMetadata.json').toPromise().then((res: any) => {
      this.requestForm = this.form.group(this.createFormModel(res.requestUtilities));
      this.requestFormData = res.requestUtilities;
      console.log(this.requestForm.value);
    })
    this.requestForm.get('state').valueChanges.subscribe(val => {
      if(this.selectedState !== val) {
        this.selectedState = val;
        this.requestForm.reset({state: val});
        this.resetData();
      }
    });
    this.requestForm.get('utilityName').valueChanges.subscribe(val => {
      if(this.selectedMarket == 'PJM')
        this.selectedPjmUtility = val;
      else
        this.selectedErcotUtility = val;
    });
    this.requestForm.get('accountNumbers').valueChanges.subscribe(val => {
      this.pjmAccounts = val;
    });
    this.requestForm.get('zone').valueChanges.subscribe(val => {
      this.selectedErcotZone = val;
    });
    this.requestForm.get('loadType').valueChanges.subscribe(val => {
      this.selectedErcotLoadType = val;
    });
    this.requestForm.get('kwhYear').valueChanges.subscribe(val => {
      this.selectedErcotKwhYear = val;
    });
    this.requestForm.get('startDate').valueChanges.subscribe(val => {
      if(this.selectedMarket == 'PJM')
        this.selectedPjmStartDate = moment(val).format("YYYY-MM-DD");
      else
        this.selectedErcotStartDate = moment(val).format("YYYY-MM-DD");
    });
    this.requestForm.get('opportunityName').valueChanges.subscribe(val => {
      if(this.selectedMarket == 'PJM')
        this.pjmOpportunityName = val;
      else
        this.ercotOpportunityName = val;
    });
  }

  getStartDateList(): void{
    const today = moment();
    let pjmStartMonth = 1;
    if(today.date() >16){
      pjmStartMonth = 2;
    }
    let pjmStartDateList = this.utilService.getStartDateList(pjmStartMonth);
    let ercotStartDateList = this.utilService.getStartDateList(0);
    this.pjmEndDate = pjmStartDateList[pjmStartDateList.length - 1]['code'];
    this.ercotEndDate = ercotStartDateList[ercotStartDateList.length - 1]['code'];
  }
  calculatePjm() {
    if(!this.validatePjmForm()){
      return;
    }
    this.showPjmResult = false;
    this.pjmError = undefined;
    this.pjmLoading = true;
    const payLoad = {
      startDate: this.selectedPjmStartDate,
      accountNumbers: this.pjmAccountList,
      utility: this.selectedPjmUtility,
      opportunityName: this.pjmOpportunityName
    }
    const requestOptions: Object = {
      responseType: 'json',
    }
    let url = environment.apiUrl + "pjm-preferred-price"
    this.http.post<any>(url, payLoad, requestOptions).subscribe(data => {
        if ('month6' in data  &&   data.month6  ) {
          this.showPjmResult = true;
          this.pjmCalculationResult = data;
          this.pjmLoading = false;
          this.dataService.restPriceGetHistory();
        } else {
          this.pjmError = "No data found!"
        }
      }
      , error => {
          this.pjmLoading = false;
          this.pjmError =  error.error.message;
      }
    );
  }
  calculateErcot() {
    this.ercotLoading = true;
    this.showErcotResult = false;
    this.ercotError = undefined;
    const payLoad = {
      utility: this.selectedErcotUtility
      , zone: this.selectedErcotZone
      , loadType: this.selectedErcotLoadType
      , startDate: this.selectedErcotStartDate
      , kwhYear: this.selectedErcotKwhYear
      , opportunityName: this.ercotOpportunityName
    }
    const requestOptions: Object = {
      responseType: 'json',

    }
    let url = environment.apiUrl + "ercot-preferred-price";
    this.http.post<any>(url, payLoad, requestOptions).subscribe(data => {
        if ('month6' in data &&   data.month6  ) {
          this.showErcotResult = true;
          this.ercotCalculationResult = data;
          this.dataService.restPriceGetHistory();
        } else {
          this.ercotError = "No data found!"

        }
        this.ercotLoading = false;

      }

      , error => {
        this.ercotLoading = false;
        this.ercotError =   error.error.message;
      }
    )
  }

  validatePjmForm() {

    this.wrongAccountNumbers =[];
    this.pjmAccountList = [];
    let accountList = this.pjmAccounts.replaceAll('\n', ',');
    accountList = accountList.replaceAll(' ', ',');
    accountList = accountList.split(',');

    for (let i = 0; i < accountList.length; i++) {
      const acct = accountList[i].trim();
      if (!acct) {
        continue;
      }
        this.pjmAccountList.push(acct);
    }

    if(this.pjmAccountList.length > 20){
      this.pjmError = 'You cant enter more than 20 account numbers';
      return false;
    }
     return this.wrongAccountNumbers.length == 0;
  }

  selectPjmUtility(utility) {

    this.selectedPjmUtility = utility.code
    if (utility.code === 'ComEd') {
      this.selectedContractType = "IL";
    } else {
      this.selectedContractType = "PA";
    }

  }

  selectErcotUtility(utility) {
    this.selectedErcotUtility = utility.code
    this.selectedContractType = "TX";
  }

  selectErcotZone(zone) {
    this.selectedErcotZone = zone.code;

  }

  selectPjmStartDate(startDate) {
    this.selectedPjmStartDate = startDate.value
  }

  selectMarket(market) {
    this.selectedMarket = market
    if (market === 'ERCOT') {
      this.selectedContractType = "TX";
    }

  }

  downloadFile(fileName) {

    const url: string = environment.apiUrl + 'download-contract/' + fileName

    this.http.get(url, {responseType: 'blob'}).subscribe((response: Blob) => {

      saveAs(response, fileName)
    });
  }

  formatPjmPrice(value) {
    let result = value;
    if(!isNaN(value)){
      result = '$'+value
    }
    return result
  }
  formatErcotPrice(value) {
    let result = value;
    if(!isNaN(value)){
      result =  value+' ¢'
    }
    return result
  }

  calculateQuote(){
    let payload = this.requestForm.value;
    let market = '';
    if(this.stateOptions.length){
      for(let item of this.stateOptions){
        if(item.utilityState === payload.state) {
          market = item.utilityMarket;
          break;
        }
      }
    }
    payload.startDate = moment(payload.startDate).format("YYYY-MM-DD");
    this.selectedPjmUtility = payload.utilityName;
    this.selectedPjmStartDate = payload.startDate;
    this.pjmAccounts = payload.accountNumber;
    this.pjmOpportunityName = payload.opportunityName;
    this.calculatePjm();
  }

  private createFormModel(metadata: any[], data?: object){
    let form = {};
    metadata.forEach(item => {
      if(item.type == 'array'){
        form[item.field] = this.form.array(item.field != 'requestFacility' ? [this.form.group(this.createFormModel(item.items))]: [])
      }else if(item.type == 'object'){
        form[item.field] = this.form.group(this.createFormModel(item.items));
      }else {
        if(item.type != 'button')
          form[item.field] = [this.setDefaultValue(item, data), item.required ? [Validators.required]: []];
      }

    })
    return form;
  }
  private setDefaultValue({field, required, defaultValue, multiple, type}, data?: object){
   return  data ? data[field]: defaultValue || (multiple ? []: type ? '': null);
  }

  getValue(field: any, item?: any, formInd?: number, parentItem?: any) {
    let requestForm;
    if(parentItem){
      requestForm = this.requestForm.get(parentItem.field) as FormGroup
    }else{
      requestForm = this.requestForm;
    }
    if(item && item.type == 'array' ){
      return requestForm.get(item.field).value[formInd][field];
    }else if(item && item.type == 'object'){
      return requestForm.get(item.field).value[field];
    }else{
      return this.requestForm.get(field).value
    }
  }

  async getStateOptions(){
    let disableStates = [];
    await this.dataService.getApiData('get-utilities/quickquotesstatenamemarket', 'GET').toPromise().then((res: any[]) => {
      this.stateOptions = res as any[];
      disableStates = res.map(item => item.utilityMarket === 'ERCOT' ? item.utilityState: undefined).filter(item => item != undefined);
      this.disableStates = disableStates;

    }).finally(() => {

    });
  }
  asyncOptionSelected(e, field: string){
    if(field === "state" && e && e.option.value){
      if(this.stateOptions.length){
        for(let item of this.stateOptions){
          if(item.utilityState === e.option.value) {
            this.selectedMarket = item.utilityMarket;
            break;
          }
        }
      }
    }
  }
  resetData(){
    this.selectedPjmUtility = "";
    this.selectedPjmStartDate = "";
    this.pjmAccounts = "";
    this.selectedErcotUtility = "";
    this.selectedErcotStartDate = "";
    this.selectedErcotKwhYear = "";
    this.selectedErcotLoadType = "";
    this.selectedErcotZone = "";
  }
}



